exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".iframelocker-component{margin:0;height:100%;width:100%;position:absolute;border:none;z-index:3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js?outputStyle=expanded!./src/styles/IframeLocker.scss
// module id = 325
// module chunks = 0